import {getSelectedDeliveryData} from '../selectors/DeliveryAddressSelectors/DeliveryAddressSelectors';
import getIsCollectionEnabled from '../selectors/getIsCollectionEnabled';
import {getDeliveryType, getSettings} from '../selectors/selectors';

export default (deliveryOptionData, getState) => {
  let hasFiltered = false;
  const state = getState();
  const isDeliveryTypePudo = getDeliveryType(state);
  const isCollection = getIsCollectionEnabled(state);
  
  if (isDeliveryTypePudo && isCollection) {
    if (deliveryOptionData?.deliveryGroups?.length > 0) {
      deliveryOptionData.deliveryGroups.forEach((deliveryGroup) => {
        if (deliveryGroup?.deliveryOptions?.length > 1) {
          const settings = getSettings(state);
          const blockedPostcodeList = settings?.filter_delivery_option_by_postcode_for_collection_type;
          if (blockedPostcodeList && deliveryGroup.deliveryOptions.some(item => !!blockedPostcodeList[`${item.id}`])) {
            const selectedAddress = getSelectedDeliveryData(state);
            const postCode = selectedAddress?.postCode;
            const santisedPostCode = postCode?.trim();
            if (santisedPostCode) {
              const indexOfDeliveryOptionToRemove = deliveryGroup.deliveryOptions
                .findIndex(item => !!blockedPostcodeList[`${item.id}`]?.length && !!blockedPostcodeList[`${item.id}`].includes(santisedPostCode));
  
              if (indexOfDeliveryOptionToRemove !== -1) {
                deliveryGroup.deliveryOptions
                  .splice(indexOfDeliveryOptionToRemove, 1);
              }
              hasFiltered = true;
            }
          }
        }
      });
    }
  }
  return {deliveryOptionData, hasFiltered};
};
